export default __webpack_public_path__ + "static/media/eco-score-placeholder.93a307ef.svg";